import { render } from "./SettingItem.vue?vue&type=template&id=3d0c3594&scoped=true"
import script from "./SettingItem.vue?vue&type=script&lang=js"
export * from "./SettingItem.vue?vue&type=script&lang=js"

import "./SettingItem.vue?vue&type=style&index=0&id=3d0c3594&lang=less&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d0c3594"]])

export default __exports__